module.exports = __webpack_public_path__ + "img/c12.c26130e3.png";